import Repository from './Repository'

const resource = 'judges'

export default {
  getJudges (tenantId, params) {
    return Repository.get(`tenants/${tenantId}/${resource}`, { params: params })
  }
}
